<loading-bar [label]="'Loging in'" *ngIf="logingIn"></loading-bar>

<div class="container" *ngIf="!logingIn">
    <mat-card class="login-card">
        <mat-card-header>
            <mat-card-title>Login</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form #loginForm="ngForm" (ngSubmit)="loginMib()" fxLayout="column">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label for="email">Email:</mat-label>
                    <input matInput [(ngModel)]="loginModel.email" name="email" required type="email">
                </mat-form-field>

                <mat-form-field class="full-width" appearance="outline">
                    <mat-label for="password">Password:</mat-label>
                    <input matInput type="password" [(ngModel)]="loginModel.password" name="password" required>
                </mat-form-field>

                <p *ngIf="error" class="error">
                    Error: {{ error }}
                </p>

                <div class="button-bar">
                    <button class="login-button" mat-raised-button color="primary" type="submit"
                        [disabled]="!loginForm.valid">Login</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>

<button class="login-button" mat-raised-button color="primary" type="submit" (click)="login()">Login CIAM</button>